import { LinkIcon, PhotoIcon } from "@heroicons/react/24/outline";
import MainButton from "../../sharedComponents/MainButton";
import { useSelector } from "react-redux";
import TextareaField from "../../sharedComponents/TextareaField";
import { useState } from "react";
import { handleFileUpload } from "../../../utils/uploadFiles";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { createPost } from "../../../slices/2-post/thunk";
import avatar from "../../../assets/images/Avatar.avif"
import InputField from "../../sharedComponents/InputField";

const CreatePostModal = ({ isOpen, onClose, companyType, companyName, company }) => {
    const { profile } = useSelector((state) => state.myProfile);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const isAdmin = profile?.role === "admin";
    const [text, setText] = useState("");
    const [isAds, setIsAds] = useState(false);
    const [image, setImage] = useState(null);
    const [adLink, setAdLink] = useState("")
    const locale = i18n.language === "ar" ? "ar" : "en";

    const [adLinkError, setAdLinkError] = useState("");
    const validateUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };
    const handleSubmit = async () => {
        const payload = {
            text,
            // isAds,
            image,
            ...(companyType && { inCompany: true }),
            ...(isAds && { url: adLink }),
        };
        // console.log(payload)
        try {
            await dispatch(createPost(payload)).unwrap();
            setText("")
            setIsAds(false)
            setImage(null)
            setAdLink("");
            onClose();
        } catch (error) {
            // console.error("Create post failed", error);
        }
    };

    // console.log(profile)
    // console.log(companyType)
    // console.log(company)
    return (
        <div
            className={`mt-0 fixed inset-0 z-[999] flex items-center justify-center transition-all duration-300 ${isOpen ? "visible" : "invisible"
                }`}
        >
            {/* Overlay */}
            <div
                onClick={onClose}
                className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
                    }`}
            />

            {/* Modal */}
            <div
                className={`relative z-10 w-full max-w-lg mx-4 p-5 rounded-2xl dark:bg-bg-dark-secondary bg-bg-light-secondary shadow-glow hover:shadow-glow-hover transform transition-all duration-300 ease-out ${isOpen
                    ? "opacity-100 scale-100 translate-y-0"
                    : "opacity-0 scale-95 translate-y-6"
                    }`}
            >
                <div className="max-h-[85vh] overflow-y-auto no-scrollbar p-1">


                    {/* Header */}
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="text-xl text-black font-xsemibold dark:text-white">

                            {t(`${companyType ? "post.createCompany" : "post.create"}`)}
                        </h2>
                        <button
                            onClick={onClose}
                            className="text-xl text-gray-400 duration-300 dark:text-gray-900 dark:hover:text-white hover:text-black"
                        >
                            ✕
                        </button>
                    </div>

                    {/* Warning Message */}
                    {!isAdmin && (
                        <div className="p-3 mb-4 text-sm text-yellow-800 bg-yellow-100 border border-yellow-300 rounded-lg">
                            {t("post.pendingApproval")}
                        </div>
                    )}

                    {/* User Info */}
                    <div className="flex items-center gap-3 mb-4">
                        <img
                            src={profile?.role === "owner" ? company?.logo || profile?.Companies?.[0]?.logo || avatar : profile?.avatar || avatar}
                            alt="avatar"
                            className="object-cover w-10 h-10 rounded-full"
                        />
                        <div>
                            <p className="font-semibold text-black dark:text-white">
                                {profile?.role === "owner" ? companyName || (locale === "ar" ? profile?.Companies?.[0]?.name_AR : profile?.Companies?.[0]?.name_EN) : profile?.fullName}
                            </p>
                            {profile?.role !== "owner" &&
                                <p className="text-sm dark:text-text-muted-dark text-text-muted-light">
                                    @{profile?.code}
                                </p>
                            }
                        </div>
                    </div>

                    {/* Textarea */}
                    <TextareaField
                        placeholder={t("post.placeholder")}
                        value={text}
                        rows={8}
                        onChange={(e) => setText(e.target.value)}
                    />

                    {/* Select Type */}
                    <div className="mt-3">
                        <div className="flex items-center gap-2 mt-3">
                            <input
                                type="checkbox"
                                id="isAds"
                                checked={isAds}
                                onChange={(e) => setIsAds(e.target.checked)}
                                className="w-4 h-4 accent-primary dark:accent-primary-light"
                            />
                            <label
                                htmlFor="isAds"
                                className="text-sm text-gray-800 cursor-pointer dark:text-gray-400"
                            >
                                {t("post.ads")}
                            </label>
                        </div>
                    </div>

                    {isAds && (
                        <div className="mt-3">
                            <InputField
                                type="text"
                                placeholder={t("post.enterAdLink")}
                                value={adLink}
                                onChange={(e) => {
                                    setAdLink(e.target.value);
                                    if (e.target.value && !validateUrl(e.target.value)) {
                                        setAdLinkError(t("validation.invalidUrl"));
                                    } else {
                                        setAdLinkError("");
                                    }
                                }}
                                icon={LinkIcon}
                            />
                            {adLinkError && (
                                <p className="mt-1 text-sm text-red-500">{adLinkError}</p>
                            )}
                        </div>
                    )}

                    {/* Add Image */}
                    <div className="mt-4">
                        <label className="flex items-center gap-2 text-sm cursor-pointer text-text-text-muted-light dark:text-text-muted-dark">
                            <PhotoIcon className="w-4 h-4" />
                            {t("post.addImage")}
                            <input
                                type="file"
                                accept="image/png, image/jpeg"
                                hidden
                                onChange={(e) =>
                                    handleFileUpload(dispatch, e.target.files[0], "images", (url) =>
                                        setImage(url)
                                    )
                                }
                            />
                        </label>
                        {image && (
                            <div className="relative w-full mt-2 h-44 rounded-xl">
                                <img
                                    src={image}
                                    alt="post"
                                    className="object-cover w-full h-full rounded-xl"
                                />

                                {/* Remove Button */}
                                <button
                                    type="button"
                                    onClick={() => setImage(null)}
                                    className="absolute flex items-center justify-center w-6 h-6 text-white transition rounded-full top-2 right-2 bg-black/50 hover:bg-black/70"
                                >
                                    ✕
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div className="flex justify-end mt-4">
                        <MainButton
                            disabled={text === "" || (isAds && (!adLink || adLinkError))}
                            onClick={handleSubmit}
                        >
                            {t("post.post")}
                        </MainButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreatePostModal;
